
















































import Vue, { PropType } from 'vue'

import DialogSummary from '@/components/widgets/dialog/DialogSummary.vue'

export type DataType = {
  markers: google.maps.Marker[],
  map: google.maps.Map | null,
  polyline: google.maps.Polyline | null,
  selectedLatLng: google.maps.LatLng | null,
  distance: number,
  isGuessButtonClicked: boolean,
  isMakeGuessButtonClicked: boolean,
  isSelected: boolean,
  dialogSummary: boolean,
}

export default Vue.extend({
  name: 'Maps',

  props: {
    randomLatLng: Object as PropType<google.maps.LatLng>,
    round: Number,
    score: Number,
  },

  components: {
    DialogSummary,
  },

  data(): DataType {
    return {
      markers: [],
      map: null,
      polyline: null,
      selectedLatLng: null,
      distance: 0,
      isGuessButtonClicked: false,
      isMakeGuessButtonClicked: false,
      isSelected: false,
      dialogSummary: false,
    }
  },

  methods: {
    showMap(): void {
      document.getElementById('map')!.style.transform = "translateY(-300px)"
      this.isMakeGuessButtonClicked = true
    },

    hideMap(): void {
      document.getElementById('map')!.style.transform = "translateY(300px)"
      this.isMakeGuessButtonClicked = false
    },

    selectLocation(): void {
      this.calculateDistance()
      this.drawPolyline()
      this.putMarker(this.randomLatLng)
      this.setInfoWindow()

      google.maps.event.clearListeners(this.map!, 'click')

      this.isGuessButtonClicked = true
      this.isSelected = true

      this.mouseOverMap()
    },

    putMarker(position: google.maps.LatLng): void {
      let marker = new google.maps.Marker({
        position: position,
        map: this.map!,
      })
      this.markers.push(marker)
    },

    removeMarkers(): void {
      for (let i in this.markers) {
        this.markers[i].setMap(null)
      }
      this.markers = []
    },

    calculateDistance(): void {
      this.distance = Math.floor(google.maps.geometry.spherical.computeDistanceBetween(this.randomLatLng, this.selectedLatLng!) / 1000)
      this.$emit('calculateDistance', this.distance)
    },

    setInfoWindow(): void {
      let infoWindow = new google.maps.InfoWindow({
        content: '<b>' + this.distance + '</b> km away!'
      })
      infoWindow.open(this.map!, this.markers[0])
    },

    drawPolyline(): void {
      this.polyline = new google.maps.Polyline({
        path: [this.selectedLatLng!, this.randomLatLng],
        strokeColor: '#FF0000',
      })
      this.polyline!.setMap(this.map!)
    },

    goToNextRound(): void {
      this.selectedLatLng = null
      this.polyline!.setMap(null)
      this.isGuessButtonClicked = false
      this.isSelected = false

      if (this.$viewport.width < 450) {
        this.hideMap()
      } else {
        this.mouseOutMap()
      }

      this.removeMarkers()
      this.$emit('goToNextRound')
    },

    playAgain(): void {
      this.selectedLatLng = null
      this.polyline!.setMap(null)
      this.isGuessButtonClicked = false
      this.isSelected = false
      this.dialogSummary = false

      if (this.$viewport.width < 450) {
        this.hideMap()
      } else {
        this.mouseOutMap()
      }

      this.removeMarkers()
      this.$emit('playAgain')
    },

    mouseOverMap(): void {
      if (this.$viewport.width > 450) {
        document.getElementById('map')!.style.opacity = '1.0'
        document.getElementById('map')!.style.transform = 'scale(1)'
        document.getElementById('map')!.style.width = '80%'
        document.getElementById('map')!.style.height = '80%'
      }
    },

    mouseOutMap(): void {
      if (this.isSelected === false && this.$viewport.width > 450) {
        document.getElementById('map')!.style.opacity = '0.7'
        document.getElementById('map')!.style.transform = 'scale(0.75)'
        document.getElementById('map')!.style.width = ''
        document.getElementById('map')!.style.height = ''
      }
    },
  },

  watch: {
    randomLatLng: function(newVal: google.maps.LatLng, oldVal: google.maps.LatLng) {
      if (newVal != null) {
        const that = this
        that.map!.addListener('click', (e) => {
          // Clear the markers and set the new one when clicking the map
          that.removeMarkers()
          that.putMarker(e.latLng)
          that.selectedLatLng = e.latLng
        })          
      }
    }
  },

  mounted(): void {
    this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
        center: {lat: 37.869260, lng: -122.254811},
        zoom: 1,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
    })      
  },
})
